import * as React from 'react'
import './index.scss'
import Pop from './../Pop'
import { reportFuc } from '../../../../utils'
interface PopInterface {
  close: any
  showAward: any
}
const { useEffect } = React
const PopInvite: React.FC<PopInterface> = props => {
  useEffect(() => {
    reportFuc('sys/pageview/ldx/invitationsuccess', '系统/页面展示/老带新/邀请成功浮层曝光', {})
  }, [])
  return (
    <Pop>
      <div className='pop-success'>
        <i className='icon' />
        <i className='close' onClick={() => props.close()} />
        <h3>邀请成功</h3>
        <p>新朋友连续登录后可领更多现金</p>
        <div className='pop-btn'
          onClick={() => {
            reportFuc('usr/click/ldx/invitationsuccess/lookup', '用户/点击/老带新/邀请成功浮层/查看奖励点击', {})
            props.showAward()
          }}
        >查看奖励</div>
      </div>
    </Pop>
  )
}

export default PopInvite